const sidebar = false;

const entity = {
  title: "Events",
  actions: {
    sort: {
      endPoint: "events/by",
      query: {
        $order: {},
      }
    },
    get: {
      endPoint: "events/by",
      query: {}
    },
    create: {
      endPoint: "events"
    },
    filter: {
      endPoint: "events/by",
      query: {
        $group: "id",
        $where: {}
      }
    }
  }
};

const keys = [{
  dataTableID: "id",
  tooltip: "ID to generate this report",
  label: "Id",
  columnType: "string",
  table: {
    displayOrder: 1
  },
  filter: {
    displayOrder: 1,
    columnType: "selectWithQuery",
    matchType: "", // Values can be gte, lte, gt, lt, By default it is eq
    options: {
      select: [{
        field: "id"
      }],
      title: ["id"],
      value: "id",
      endPoint: "events/by",
      separator: " ",
      initializer: "",
      query: {
        $where: {
          id: "$input"
        }
      },
      keyFinder: "$input"
    }
  }
},
{
  dataTableID: "title",
  tooltip: "Title of the events",
  label: "Title",
  columnType: "string",
  create: {
    displayOrder: 1
  },
  table: {
    displayOrder: 2
  },
  filter: {
    displayOrder: 2
  }
}
];

const tabs = [{
  view: "detailView",
  entity: "events",
  endPoint: "events/by",
  title: "Details",
  queryFilter: {
    id: ":id"
  }
}];

export {
  sidebar,
  entity,
  keys,
  tabs
};